module.exports = __webpack_public_path__ + "images/butler/automation-dark.8548e886880fadc385da.svg";